import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React__default, { forwardRef, useState, useRef, useLayoutEffect } from 'react';
import { Slot } from '@radix-ui/react-slot';
import useCombinedRefs from '../../utils/use-combined-refs.js';
import cx from 'classnames';
import { Classes } from '@blueprintjs/core';
import { TooltipV2 } from '../tooltip-v2/tooltip-v2.js';

var _excluded = ["className", "asChild", "children", "ellipsize"];
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _elRef$current;

  var className = _ref.className,
      asChild = _ref.asChild,
      children = _ref.children,
      ellipsize = _ref.ellipsize,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  var elRef = useRef(null);
  var combinedRef = useCombinedRefs(elRef, ref);
  var classes = cx(className, _defineProperty({}, Classes.TEXT_OVERFLOW_ELLIPSIS, ellipsize)); // following blueprint example for now. A smarter strategy would be to use a resize observer
  // but this'll do for now.

  useLayoutEffect(function () {
    if (ellipsize && elRef.current) {
      var newShowTooltip = elRef.current.scrollWidth > elRef.current.clientWidth;

      if (showTooltip !== newShowTooltip) {
        setShowTooltip(newShowTooltip);
      }
    }
  });
  var content = showTooltip ? (_elRef$current = elRef.current) === null || _elRef$current === void 0 ? void 0 : _elRef$current.textContent : null;

  if (asChild) {
    return /*#__PURE__*/React__default.createElement(TooltipV2, {
      content: content
    }, /*#__PURE__*/React__default.createElement(Slot, _extends({
      className: classes
    }, props, {
      ref: combinedRef
    }), children));
  }

  return /*#__PURE__*/React__default.createElement(TooltipV2, {
    content: content
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, props, {
    ref: combinedRef
  }), children));
});

export { Text };
//# sourceMappingURL=text.js.map
